import { render, staticRenderFns } from "./courseCreaterTip.vue?vue&type=template&id=bc8208e4&scoped=true"
import script from "./courseCreaterTip.vue?vue&type=script&lang=js"
export * from "./courseCreaterTip.vue?vue&type=script&lang=js"
import style0 from "./courseCreaterTip.vue?vue&type=style&index=0&id=bc8208e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc8208e4",
  null
  
)

export default component.exports